import React, { useState, useEffect, useRef, useCallback } from "react";
import L from "leaflet";
import { FaCircleInfo } from "react-icons/fa6";

const Information = () => {
  const [open, setOpen] = useState(false);
  const infoRef = useRef(null);
  const infoPanelRef = useCallback((node) => {
    infoRef.current = node;
    if (node) {
      L.DomEvent.disableClickPropagation(node);
      L.DomEvent.disableScrollPropagation(node);
    }
  }, []);
  // Leaflet's own drag/click handling swallows clicks on overlay controls
  // unless propagation to the map is explicitly disabled on the DOM node.
  const btnRef = useCallback((node) => {
    if (node) {
      L.DomEvent.disableClickPropagation(node);
      L.DomEvent.disableScrollPropagation(node);
    }
  }, []);

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (infoRef.current && !infoRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    if (open) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  // Content for the Info component, directly defined here
  const infoContent = (
    <div>
      <p style={{fontSize: '1em', marginBottom: '5px'}}>This page contains Historical Fire risk forecast data.</p>
    </div>
  );

  return (
    <div style={{ position: "absolute", bottom: "20px", left: "12px", zIndex: 1000 }}>
      {/* Info Button */}
      <button
        ref={btnRef}
        onClick={() => setOpen(!open)}
        title="More Info"
        style={{
          background: "rgba(255, 255, 255, 0.15)",
          backdropFilter: "blur(10px) brightness(1.1)",
          WebkitBackdropFilter: "blur(10px) brightness(1.1)",
          border: "1px solid rgba(255, 255, 255, 0.25)",
          borderRadius: "8px",
          padding: "8px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          fontSize: 16,
          color: "white",
          transition: "transform 0.2s",
        }}
        aria-label="Show info"
        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1.0)")}
      >
        <FaCircleInfo />
      </button>

      {/* Info Card */}
      {open && (
        <div
          ref={infoPanelRef}
          style={{
            position: "absolute",
            bottom: 30,
            left: 0,
            minWidth: 260,
            maxWidth: 350,
            background: "#fff",
            borderRadius: 12,
            boxShadow: "0 4px 24px rgba(0,0,0,0.15)",
            padding: "16px 18px",
            fontSize: 13,
            color: "#333",
            zIndex: 1000,
            animation: "fadeIn 0.3s ease",
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
            <h5 style={{ fontWeight: 600, color: "#000" }}>Information</h5>
            <button
              onClick={() => setOpen(false)}
              style={{
                background: "none",
                border: "none",
                fontSize: 18,
                cursor: "pointer",
                color: "#888",
              }}
              aria-label="Close info"
            >
              ×
            </button>
          </div>
          <div>{infoContent}</div> {/* Render the defined content here */}
        </div>
      )}

      {/* Fade-in Animation (consider moving to a CSS file for global styles) */}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(5px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default Information;